export const GRADE_K2_TIERED_INTERVENTIONS = 'k-2_curriculum_tier2'
export const GRADE_35_TIERED_INTERVENTIONS = '3-5_curriculum_tier2'
export const GRADE_68_TIERED_INTERVENTIONS = '6-8_curriculum_tier2'

export const K5_PROGRAM_TYPE = 'k5SelDigital'
export const MSP_PROGRAM_TYPE = 'mspDigital'
export const HIGH_SCHOOL_PROGRAM_TYPE = 'highSchool'
export const DWB_PROGRAM_TYPE = 'dwb'

// Program-less curriculum-service content group that hosts the cross-program
// educator dashboard pages (e.g. the High School dashboard's dashboardProgram).
export const EDUCATOR_DASHBOARD_CONTENT_GROUP_CODE = 'educatorDashboard'

/**
 * Maps program codes (K5P, MSP, HSP) to program keys (k5SelDigital, mspDigital, highSchool)
 * Used for converting between API program codes and userAccess/userContext program keys
 */
export const PROGRAM_CODE_TO_KEY_MAP = {
  K5P: K5_PROGRAM_TYPE,
  MSP: MSP_PROGRAM_TYPE,
  HSP: HIGH_SCHOOL_PROGRAM_TYPE,
}

export const TICourseNameToProgramMap = {
  [GRADE_K2_TIERED_INTERVENTIONS]: K5_PROGRAM_TYPE,
  [GRADE_35_TIERED_INTERVENTIONS]: K5_PROGRAM_TYPE,
  [GRADE_68_TIERED_INTERVENTIONS]: MSP_PROGRAM_TYPE,
}

export const OVERALL_PROGRAM_LIST = [
  K5_PROGRAM_TYPE,
  MSP_PROGRAM_TYPE,
  HIGH_SCHOOL_PROGRAM_TYPE,
]

export const TIERED_INTERVENTION_PROGRAM_LIST = [
  K5_PROGRAM_TYPE,
  MSP_PROGRAM_TYPE,
]

export const programKeyMap = {
  'digital-well-being': DWB_PROGRAM_TYPE,
  elementary: 'K5SelDigital',
  'middle-school': 'MspDigital',
  highSchool: 'HighSchool',
}
